import React, { useEffect } from 'react';
import Repository from 'repositories/Repository';
import { useStore, StoreTypes } from 'context';
import * as types from 'constants/actionTypes';
import { SplitType } from 'constants/splitType';

const { ExtendedResourceRepository } = Repository;
const SynopsisUpdate = ({children,synopsisInfo}) => {
    const { tab,list } = synopsisInfo;
    const [{ bookId }] = useStore(StoreTypes.books);
    const [{ splitType, shouldSplited, synopsisTab }, extendedContentDispatch] = useStore(
        StoreTypes.extendedContent
    );

    useEffect(()=>{
        // 寫入extendedContentStore - synopsisTab
        extendedContentDispatch({
            type: types.SET_EXTENDED_CONTENT_SYNOPSIS_TAB,
            payload: {
                synopsisTab : (tab - 1)
            }
        });
    },[extendedContentDispatch, tab]);

    useEffect(() => {
      Promise.all(
        list.map((lists) => {
          const currentSplitType = (lists && lists.splitType) || SplitType.NO_SPLIT;
          if (currentSplitType === SplitType.MANUAL_SPLIT) {
            return ExtendedResourceRepository.getManualSplitHtml({
              bookId,
              filename: lists.src,
            });
          }
          return ExtendedResourceRepository.getJSONContent({
            bookId,
            pathName: lists.src,
          });
        })
      ).then((obj) => {
        // 寫入extendedContentStore - synopsisList
        extendedContentDispatch({
          type: types.SET_EXTENDED_CONTENT_SYNOPSIS_LIST,
          payload: {
            synopsisList: obj,
          },
        });
      });
    }, [bookId, extendedContentDispatch, list]);

    // 關閉小視窗（modal unmount）時清空 store 的 synopsisList。
    // synopsisList 只屬於「當前開著的視窗」，但 store 預設不會在關窗時重置；
    // 下次開啟不同視窗時，新內容尚未 fetch 回來前，SynopsisWindow 的分頁 effect
    // 會先讀到上一個視窗的殘留內容並渲染出來（NBK-1517：先顯示前一視窗殘影再閃回）。
    // 關窗即清空，可避免 reopen 時顯示錯誤殘影。
    useEffect(() => {
      return () => {
        extendedContentDispatch({
          type: types.SET_EXTENDED_CONTENT_SYNOPSIS_LIST,
          payload: { synopsisList: [] },
        });
      };
    }, [extendedContentDispatch]);

    // 同步目前 tab 的 splitType 到 store，讓既有功能都以「目前 tab」為準
    useEffect(() => {
      if (!list || !Array.isArray(list) || list.length === 0) return;
      const tabItem = list[synopsisTab];
      const tabSplitType = (tabItem && tabItem.splitType) || SplitType.NO_SPLIT;
      if (tabSplitType === splitType) return;

      extendedContentDispatch({
        type: types.SET_EXTENDED_CONTENT_SPLIT_INFO,
        payload: {
          splitType: tabSplitType,
          shouldSplited,
        },
      });
    }, [extendedContentDispatch, list, shouldSplited, splitType, synopsisTab]);

    return (
        <div>{children}</div>
    )
}

export default SynopsisUpdate;
